import { h, Fragment } from '@stencil/core/internal/client';
import { h as hasSlot } from './slot.js';

const getLabelId = (inputId) => `label-${inputId}`;
const getHelpTextId = (inputId) => `help-text-${inputId}`;
const getErrorTextId = (inputId) => `error-text-${inputId}`;
/**
 * @part control - The wrapper of the form control element
 * @part label - The label of the form control
 * @part help - The help text of the form control
 * @part error - The error text of the form control
 */
const FormControl = ({ element, class: className, formControlId, inline = false, fieldset = false, required = false, disabled = false, invalid = false, label = '', hideLabel = false, helpText = '', errorText = '', }, children) => {
  const hasHelpText = helpText || (element && hasSlot(element, 'help'));
  const hasErrorText = errorText || (element && hasSlot(element, 'error'));
  return (h("div", { part: "control", class: Object.assign({ 'form-control': true, 
      // States
      'form-control--disabled': disabled, 'form-control--invalid': invalid, 'form-control--required': required, 'form-control--display-error': invalid && !disabled && errorText.length > 0 }, (typeof className === 'object' ? className : className && { [className]: true })), "data-help-text": helpText, "data-error-text": errorText },
    fieldset ? (h("fieldset", { class: hideLabel ? 'fieldset-no-label' : '', disabled: disabled },
      !hideLabel && (h("legend", { class: "form-control__label", part: "label" }, label)),
      children)) : !hideLabel ? (h(Fragment, null,
      h("label", { id: getLabelId(formControlId), htmlFor: formControlId },
        h("span", { class: "form-control__label", part: "label" }, label),
        inline && children),
      !inline && children)) : (h(Fragment, null, children)),
    h("p", { id: getHelpTextId(formControlId), class: "help-text", "data-empty": !hasHelpText, part: "help" },
      h("slot", { name: "help" }, helpText)),
    h("p", { id: getErrorTextId(formControlId), class: "error-text", "data-empty": !hasErrorText, "aria-live": "polite", part: "error" },
      h("slot", { name: "error" }, errorText))));
};

export { FormControl as F, getHelpTextId as a, getErrorTextId as b, getLabelId as g };
